export default "__VITE_ASSET__59a5d9a6__"